module.exports = __webpack_public_path__ + "static/media/ornamentalWhite1.32315724.PNG";